module.exports = __webpack_public_path__ + "static/media/pic2.18629f81.jpeg";